import type { MobileNavItem } from 'components/mobileNavV2/MobileNavData';
import type { MobileNavLink } from 'components/MobileNavV3/MobileNavMenu/MobileNavMenuData/MobileNavMenuData';

const sharedLinks = [
  { title: 'New Arrivals', path: '/shop/collection/wedding-shop-new-arrivals' },
  { title: 'Bridal Boutique', path: '/shop/category/bridal-boutique' },
  { title: 'Wedding Party', path: '/shop/category/gifts-for-the-wedding-party' },
  { title: 'Gifts & Favors', path: '/shop/category/wedding-gifts-favors' },
  { title: 'Party Supplies & Decor', path: '/shop/category/party-supplies-decor' },
  { title: 'Accessories', path: '/shop/category/wedding-shop-accessories' },
  { title: 'Jewelry', path: '/shop/category/wedding-jewelry' },
  { title: 'Intimates', path: '/shop/category/wedding-intimates' },
  { title: 'Beauty & Wellness', path: '/shop/category/health-wellness' },
];

const getWeddingBoutiqueLinks = (): MobileNavItem[] => [
  { title: 'The Wedding Boutique', path: '/shop/category/wedding-shop' },
  ...sharedLinks,
];

// Currently just one group of links
export const getMobileBoutiqueMenuData = (): MobileNavLink[][] => [
  [{ title: 'See all in Boutique', path: '/shop/category/wedding-shop' }, ...sharedLinks],
];

export default getWeddingBoutiqueLinks;
